import React from 'react';
import './header.css'
import logo from '../../assets/logo.png'
import Cta from '../common/cta';
import pic2 from '../../assets/pic2.png'
import { useState } from 'react';
import pic3 from '../../assets/pic3.png'
import { supabase } from '../../supabase';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';


const Header = () => {
      const [open, setOpen] = useState(false);
const [navs, setnavs]= useState([]);
const [ctaa, setctaa]= useState([]);

useEffect(() => {
const getnav = async()=>{
    const res = await supabase.from('nav-header_content').select('*').order('id', { ascending: true });;
setnavs(res.data);
}
getnav();
}, []);



  useEffect(() => {
  const getcta = async()=>{
      const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;

  setctaa(res.data);
  }
  getcta();
  }, []);




    return ( 
        <header className='header-container'>
            <nav className='header'>
             <Link to='/' >
                <img src={logo} alt='logo' className='logoo'></img>
</Link>
                <ul className='list-header'>
                    {navs?.map((item) => (
                        <NavLink
                        key={item.id}
                        to={item.url}
                        className={({ isActive }) =>
                            isActive ? 'noneactive-header active' : 'noneactive-header'
                        }
                        >
                        {item.name}
                        </NavLink>
                    ))}
                    <nav className='cta-container-header'>
                        <Cta  title={ctaa?.[21]?.cta} />
                    </nav>   
                     <nav className='cta-container-header'>
                        <Cta  title={ctaa?.[21]?.cta2}  />
                    </nav> 

                    <img className='burgermenu' src={pic2} alt='pic'
                      onClick={() => setOpen(true)}></img>
                                              
                </ul>
            </nav>


        <div
            className={`overlay ${open ? 'show' : ''}`}
            onClick={() => setOpen(false)}
        />

        <aside className={`sidebar ${open ? 'open' : ''}`}>
                <img
                src={pic3}
                alt="close"
                className="close-icon"
                onClick={() => setOpen(false)}
                />
                <div className="sidebar-content">
                    {navs?.map((item) => (
                        <NavLink
                        key={item.id}
                        to={item.url}
                        className={({ isActive }) =>
                            isActive ? 'noneactive-header active' : 'noneactive-header'
                        }
                        >
                        {item.name}
                        </NavLink>
                    ))}

            <div className="sidebar-cta">
                <Cta title={ctaa?.[21]?.cta} />
                <Cta title={ctaa?.[21]?.cta2}  />
            </div>
            </div>
        </aside>


        </header>
     );
}
 
export default Header;